module.exports = __webpack_public_path__ + "img/tag.ce6a2c7f.svg";